import { render, staticRenderFns } from "./RegisterTour.vue?vue&type=template&id=22e7f5cc&scoped=true"
import script from "./RegisterTour.vue?vue&type=script&lang=js"
export * from "./RegisterTour.vue?vue&type=script&lang=js"
import style0 from "./RegisterTour.vue?vue&type=style&index=0&id=22e7f5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e7f5cc",
  null
  
)

export default component.exports